import { render, staticRenderFns } from "./DeliveryAddresses.vue?vue&type=template&id=1e389126&"
import script from "./DeliveryAddresses.js?vue&type=script&lang=js&"
export * from "./DeliveryAddresses.js?vue&type=script&lang=js&"
import style0 from "./DeliveryAddresses.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports